module.exports = __webpack_public_path__ + "img/Image6.1b68b9d3.png";